import { FullRouteNavItem, NavItem } from '../models/nav-item.model';

export function buildFullRouteNavItems(
  navItems: NavItem[],
  parentModuleName = '',
  parentRoute = ''
): FullRouteNavItem[] {
  return navItems.map(navItem => {
    const moduleName = parentModuleName || navItem.route;
    const route = parentRoute + (navItem.route ? `/${navItem.route}` : '');

    return {
      ...navItem,
      children: navItem.children ? buildFullRouteNavItems(navItem.children, moduleName, route) : undefined,
      module: moduleName,
      route,
    };
  });
}
